import { Component } from '@angular/core';

@Component({
  selector: 'aryel-join',
  template: '<ui-view></ui-view>',
})
export class JoinComponent {}
